import { render } from "./Header.vue?vue&type=template&id=557a48be&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=557a48be&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557a48be"]])

export default __exports__